import { render, staticRenderFns } from "./ExporIBM.vue?vue&type=template&id=788a78e5&scoped=true&"
import script from "./ExporIBM.vue?vue&type=script&lang=js&"
export * from "./ExporIBM.vue?vue&type=script&lang=js&"
import style0 from "./ExporIBM.vue?vue&type=style&index=0&id=788a78e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a78e5",
  null
  
)

export default component.exports